import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'crop-16-9', 'Crop169', [["path",{"d":"M4 10a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2l0 -4"}]]);